import { render, staticRenderFns } from "./FarmaciaCbasico.vue?vue&type=template&id=0d99ea99&"
import script from "./FarmaciaCbasico.vue?vue&type=script&lang=js&"
export * from "./FarmaciaCbasico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports